// Filtering moves the view automatically; wait for fresh gallery input before
// showing the centered item again.
export function resetCrumbTracking(gallery) {
    gallery._crumbTrackingStarted = false;
    gallery._crumbVisible = false;
    gallery._crumbItem = null;
    gallery.updateCrumb(null);
}
